
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faAngleUp as falAngleUp,
    } from '@fortawesome/pro-light-svg-icons/faAngleUp';

    import {
        faAngleDown as falAngleDown,
    } from '@fortawesome/pro-light-svg-icons/faAngleDown';

    export default {
        name: 'VueSelect',

        components: {
            FontAwesomeIcon,
        },

        props: {
            options: {
                type: Array,
                default: () => [],
            },

            value: {
                type: [String, Number],
                default: '',
            },

            defaultText: {
                type: String,
                default: '',
            },

            dropdownDirection: {
                type: String,
                default: 'right',
            },

            isInvalid: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                selectedOption: {},
                isMenuOpen: false,
                icons: {
                    falAngleUp,
                    falAngleDown,
                },
            };
        },

        computed: {
            classList() {
                return [
                    'vue-select',
                    this.getInvalidClass,
                    this.getOpenClass,
                ];
            },

            getInvalidClass() {
                return this.isInvalid ? 'is-invalid' : '';
            },

            getOpenClass() {
                return this.isMenuOpen ? 'is-open' : '';
            },
        },

        watch: {
            isMenuOpen(value) {
                this.$emit('isMenuOpen', value);
            },
        },

        created() {
            if (this.options.length) {
                const defaultOption = this.options.filter(o => o.value === this.value);
                if (defaultOption.length) {
                    this.selectOption(defaultOption[0]);
                } else {
                    this.selectOption(this.options[0]);
                }
            }
        },

        methods: {
            selectOption(option) {
                if (option.value !== this.selectedOption.value) {
                    this.selectedOption = option;
                    this.$emit('input', option.value);
                }

                this.closeMenu();
            },

            selectFromOptions(option) {
                if (option.value !== this.selectedOption.value) {
                    this.selectedOption = option;
                    this.$emit('input', option.value);
                    this.$emit('select', option.value);
                }

                this.closeMenu();
            },

            toggleMenu() {
                this.isMenuOpen = !this.isMenuOpen;
            },

            closeMenu() {
                this.isMenuOpen = false;
            },
        },
    };
